import { render, staticRenderFns } from "./PageMessages.vue?vue&type=template&id=f55746dc&"
import script from "./PageMessages.vue?vue&type=script&lang=js&"
export * from "./PageMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports